/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const SearchIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M15.8906 15.05L11.8594 11.0188C11.7875 10.9469 11.6938 10.9094 11.5938 10.9094H11.2719C12.3438 9.75 13 8.20312 13 6.5C13 2.90937 10.0906 0 6.5 0C2.90937 0 0 2.90937 0 6.5C0 10.0906 2.90937 13 6.5 13C8.20312 13 9.75 12.3438 10.9094 11.275V11.5938C10.9094 11.6938 10.95 11.7875 11.0188 11.8594L15.05 15.8906C15.1969 16.0375 15.4344 16.0375 15.5813 15.8906L15.8906 15.5813C16.0375 15.4344 16.0375 15.1969 15.8906 15.05ZM6.5 12C3.45937 12 1 9.54062 1 6.5C1 3.45937 3.45937 1 6.5 1C9.54062 1 12 3.45937 12 6.5C12 9.54062 9.54062 12 6.5 12Z"
        fill={color}
      />
    </svg>
  );
};
